/**
 * DEMO: Configuración Multi-Empresa
 * Datos de empresas para simulación (SIN tocar BD)
 * 
 * Para volver a SiBus original: Solo cambiar empresaActual a 'sibus'
 */

export const EMPRESAS_DEMO = {
  sibus: {
    id: 1,
    nombre: 'SiBus',
    razonSocial: 'SiBus Transporte S.A.',
    nombreSistema: 'SiBus',
    slogan: 'SiBus',
    
    // Logos
    logo: '/assets/empresas/sibus/logo.png',
    logoSmall: '/assets/empresas/sibus/logo-sm.png',
    favicon: '/assets/empresas/sibus/favicon.ico',
    
    // Colores (rosa/fucsia SiBus)
    theme: {
      primary: '#ff00b3',      // Rosa/Fucsia
      secondary: '#dc004e',    // Rosa/Rojo oscuro
      background: '#ffffff',
      text: '#000000',
      sidebar: '#263238',
      sidebarText: '#ffffff',
      success: '#4caf50',
      warning: '#ff9800',
      error: '#f44336',
      info: '#2196f3'
    }
  },
  
  gruposarmiento: {
    id: 2,
    nombre: 'Grupo Sarmiento',
    razonSocial: 'Grupo Sarmiento S.A.',
    nombreSistema: 'Sarmiento',
    slogan: 'Grupo Sarmiento',
    
    // Logos
    logo: '/assets/empresas/gruposarmiento/logo.png',
    logoSmall: '/assets/empresas/gruposarmiento/logo-sm.png',
    favicon: '/assets/empresas/gruposarmiento/favicon.png',
    
    // Colores (gris y verde)
    theme: {
      primary: '#22c55e',      // Verde moderno
      secondary: '#4b5563',    // Gris medio
      background: '#ffffff',
      text: '#1f2937',
      sidebar: '#1f2937',      // Gris oscuro
      sidebarText: '#ffffff',
      success: '#22c55e',
      warning: '#f59e0b',
      error: '#ef4444',
      info: '#3b82f6'
    }
  },
  
  intercordoba: {
    id: 3,
    nombre: 'Intercórdoba',
    razonSocial: 'Intercórdoba Transporte S.A.',
    nombreSistema: 'InterCordoba',
    slogan: 'InterCorbda',
    
    // Logos
    logo: '/assets/empresas/intercordoba/logo.png',
    logoSmall: '/assets/empresas/intercordoba/logo-sm.png',
    favicon: '/assets/empresas/intercordoba/favicon.ico',
    
    // Colores (gris con rojo)
    theme: {
      primary: '#E53935',      // Rojo
      secondary: '#78909C',    // Gris
      background: '#ffffff',
      text: '#263238',
      sidebar: '#455A64',      // Gris medio
      sidebarText: '#ffffff',
      success: '#43A047',
      warning: '#FB8C00',
      error: '#D32F2F',
      info: '#1E88E5'
    }
  }
};

// ============================================
// CONFIGURACIÓN ACTUAL (CAMBIAR AQUÍ)
// ============================================
// Opciones: 'sibus', 'gruposarmiento', 'intercordoba'

export const EMPRESA_ACTUAL = 'gruposarmiento';  // ← CAMBIAR AQUÍ PARA DEMO

// ============================================

/**
 * Obtener configuración de empresa actual
 */
export const getEmpresaActual = () => {
  const empresaKey = localStorage.getItem('empresa-demo') || EMPRESA_ACTUAL;
  return EMPRESAS_DEMO[empresaKey] || EMPRESAS_DEMO.sibus;
};

/**
 * Cambiar empresa (para demo)
 */
export const setEmpresaDemo = (empresaKey) => {
  if (EMPRESAS_DEMO[empresaKey]) {
    localStorage.setItem('empresa-demo', empresaKey);
    // Recargar página para aplicar cambios
    window.location.reload();
  }
};

/**
 * Obtener lista de empresas disponibles
 */
export const getEmpresasDisponibles = () => {
  return Object.keys(EMPRESAS_DEMO).map(key => ({
    key,
    ...EMPRESAS_DEMO[key]
  }));
};

/**
 * Aplicar tema CSS variables
 */
export const aplicarTemaEmpresa = (empresa) => {
  const root = document.documentElement;
  
  Object.entries(empresa.theme).forEach(([key, value]) => {
    root.style.setProperty(`--color-${key}`, value);
  });
  
  // Actualizar meta theme-color
  const metaThemeColor = document.querySelector('meta[name="theme-color"]');
  if (metaThemeColor) {
    metaThemeColor.setAttribute('content', empresa.theme.primary);
  }
  
  // Actualizar título de la página
  document.title = empresa.nombreSistema;
  
  // Actualizar favicon
  const favicon = document.querySelector('link[rel="icon"]');
  if (favicon) {
    favicon.href = empresa.favicon;
  }
};

export default EMPRESAS_DEMO;
